import React from 'react';
import { Box } from '@mui/material';

import { PlatePair } from '@paragon/contract-library';

import {
  PlateAngleInput,
  PlateDimensionsSelect,
  PlateManufacturerProperty,
  PlateTypeSelect,
} from '../../interface/subpanels/properties/PlatePairProperties';
import { SceneMenuReplacement } from '../menus/common/SceneMenuReplacement';

interface Props {
  platePairs: PlatePair[];
}

export function EditPlatePairMenuReplacement({ platePairs }: Props) {
  return (
    <SceneMenuReplacement
      id="edit"
      minWidth="400px"
      sx={{ padding: 1 }}
      title={platePairs.length === 1 ? 'Edit Plate Pair' : `Edit ${platePairs.length} Plate Pairs`}
    >
      <Box sx={{ display: 'flex', gap: 1 }}>
        <PlateManufacturerProperty platePairs={platePairs} />
        <PlateTypeSelect platePairs={platePairs} />
      </Box>

      <Box sx={{ display: 'flex', gap: 1 }}>
        <PlateDimensionsSelect platePairs={platePairs} />
        <PlateAngleInput platePairs={platePairs} />
      </Box>
    </SceneMenuReplacement>
  );
}
